import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

const CreditProgressRing = ({ used = 0, limit = 0 }) => {
  const pct = limit > 0 ? Math.min((used / limit) * 100, 100) : 0;
  return (
    <div className="w-32 mx-auto mb-6">
      <CircularProgressbar
        value={pct}
        text={`${Math.round(pct)}%`}
        styles={buildStyles({
          textColor: '#374151',
          pathColor: pct > 90 ? '#DC2626' : '#10B981',
          trailColor: '#E5E7EB',
        })}
      />
      <p className="text-center mt-2 text-sm text-heading">
        Credit used
      </p>
    </div>
  );
};

CreditProgressRing.propTypes = {
  used : PropTypes.number,
  limit: PropTypes.number,
};
export default CreditProgressRing;
